export default __webpack_public_path__ + "static/Calendar2021-21a37aa285ae2e897c27d5471df78ff4.png";